<div class="modal-header bg-light" appCustomAutofocus>
    Thanks for logging into the {{companyName}}
</div>
<div class="modal-body">
    <div class="row" *ngIf="alert">
        <div class="col-12">
            <div class="alert" [ngClass]="{'alert-success' : alert.type == 'success', 'alert-default' : alert.type == 'default', 'alert-danger': alert.type == 'danger' }" role="alert">
                {{alert.msg}}
            </div>
        </div>
    </div>
    <p>Please confirm your paperless document settings.</p>
    <div class="card border" *ngIf="formData.showPayStub">
        <div class="card-body">
            <strong>Paperless Paystub Delivery Consent</strong>
            <p style="margin-left:10px;">{{formData.ElectronicPaystubVerbiage}}</p>
            <div class="col-md-12 btn-group">
                <div [ngClass]="{WebMode : !mobileMode}">
                    <input type="radio" name="first" value="1" [(ngModel)]="formData.ElectronicPaystubConsent"> Yes, I consent to view my paystubs electronically<br>
                    <input type="radio" name="first" value="0" [(ngModel)]="formData.ElectronicPaystubConsent"> I do NOT want to view my paystubs electronically<br>
                </div>
            </div>
        </div>
    </div>
    <div class="card border" *ngIf="formData.showW2">
        <div class="card-body">
            <strong><span *ngIf="formData.EmployeeCountry == 'US'">W-2</span><span *ngIf="formData.EmployeeCountry == 'CA'">T4</span> Paperless Delivery Consent</strong>
            <p style="margin-left:10px;">{{formData.W2DocumentVerbiage}}</p>
            <div class="col-md-12 btn-group">
                <div [ngClass]="{WebMode : !mobileMode}">
                    <input type="radio" name="second" value="1" [(ngModel)]="formData.W2DocumentConsent"> Yes, I consent to view my <span *ngIf="formData.EmployeeCountry == 'US'">W-2</span><span *ngIf="formData.EmployeeCountry == 'CA'">T4</span> electronically<br>
                    <input type="radio" name="second" value="0" [(ngModel)]="formData.W2DocumentConsent"> I do NOT want to view my <span *ngIf="formData.EmployeeCountry == 'US'">W-2</span><span *ngIf="formData.EmployeeCountry == 'CA'">T4</span> electronically<br>
                </div>
            </div>
        </div>
    </div>
    <div class="card border" *ngIf="formData.EmployeeCountry == 'US' && formData.showC1095">
        <div class="card-body">
            <strong>1095-C Paperless Delivery Consent</strong>
            <p style="margin-left:10px;">{{formData.C1095DocumentVerbiage}}</p>
            <div class="col-md-12 btn-group">
                <div [ngClass]="{WebMode : !mobileMode}">
                    <input type="radio" name="third" value="1" [(ngModel)]="formData.C1095DocumentConsent"> Yes, I consent to view my Form 1095-C electronically<br>
                    <input type="radio" name="third" value="0" [(ngModel)]="formData.C1095DocumentConsent"> I do NOT want to view my Form 1095-C electronically<br>
                </div>
            </div>
        </div>
    </div>
    <div class="card border" *ngIf="allowInfoChange" [hidden]="!personalInfoLoaded">
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <strong>Personal Information</strong>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6" *ngIf="allowInfoChange && formData.CellLabel != null">
                    <strong>{{formData.CellLabel}}: </strong>
                    <span style="padding-left:0px; padding-top:2px; padding-bottom:2px;" class="badge badge-primary" *ngIf="formData.CellPending">
                        <i style="margin-right:6px;" class="oi oi-clock">
                        </i>Pending
                    </span>
                    <input type="text" class="form-control" placeholder="{{phoneMask}}" style="margin-bottom: 12px;"
                           [disabled]="formData.CellPhoneFieldUpdateMode == 1" (change)="validatePhone()"
                           [(ngModel)]="formData.CellPhone"
                           [ngClass]="{ 'is-invalid': inValidPhone}" appPhoneFormat (valueChange)="updateCellPhone($event)" />

                </div>
                <div class="col-md-6" *ngIf="showPaperlessCarrier">
                    <strong>{{formData.CellCarrierLabel}}: </strong>
                    <span style="padding-left:0px; padding-top:2px; padding-bottom:2px;" class="badge badge-primary" *ngIf="formData.CellCarrierPending">
                        <i style="margin-right:6px;" class="oi oi-clock">
                        </i>Pending
                    </span>
                    <ng-select bindLabel="DisplayValue"
                               [searchable]="false"
                               [clearable]=false
                               [disabled]="formData.CellCarrierFieldUpdateMode == 1"
                               [(ngModel)]="formData.CellCarrier"
                               dropdownPosition="bottom"
                               ngbTooltip="{{carrierMissingMsg}}"
                               [ngClass]="{ 'is-invalid': carrierMissingMsg != null}">
                        <ng-option *ngFor="let carrier of cellCarriers" [value]="carrier.DatabaseValue">{{carrier.DisplayValue}}</ng-option>
                    </ng-select>
                </div>
            </div>
            <div class="row" *ngIf="allowInfoChange">
                <div class="col-md-6">
                    <strong>{{formData.EmailLabel}}: </strong>
                    <span style="padding-left:0px; padding-top:2px; padding-bottom:2px;" class="badge badge-primary" *ngIf="formData.EmailPending">
                        <i style="margin-right:6px;" class="oi oi-clock">
                        </i>Pending
                    </span>
                    <input type="email" class="form-control" style="margin-bottom: 12px;"
                           [disabled]="formData.EmailFieldUpdateMode == 1"
                           [(ngModel)]="formData.Email" [required]="requirePersonalInfo" />
                </div>
                <div class="col-md-6">
                    <strong>Opt out of non-emergency SMS?</strong>
                    <input type="checkbox" class="form-control" style="margin-bottom: 12px;width:25px;height:25px;"
                           [(ngModel)]="formData.optOutSMS" />
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer" style="z-index: -100;">
    <img [hidden]="!processing" src="/Cache/images/icon_load.gif" alt="Loading..." />
    <button class="btn btn-success" type="button" (click)="confirmClicked()" [disabled]="processing || inValidPhone ||
                (requirePersonalInfo && (allowInfoChange && (formData.Email == null  || formData.Email == '' || formData.CellPhone == null || formData.CellPhone == ''))) ||
                (requirePersonalInfo && (allowInfoChange && showPaperlessCarrier && (formData.CellCarrierLabel == null || emptyCarrierList|| formData.CellCarrier == null))) ||
                (formData.ElectronicPaystubConsent == null && formData.showPayStub )||
                (formData.W2DocumentConsent == null && formData.showW2 )||
                (formData.C1095DocumentConsent == null && formData.EmployeeCountry == 'US' && formData.showC1095)">
        Confirm My Paperless Settings
    </button>
</div>


